import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_SUBSCRIPTION_FAMILY_LIST_SAGA } from "../sagaTypes";
import { loaderAction, familyFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";
import { FAMILY_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_family_list`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateSubscriptionFamilyList(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.data.subscription_id);
        formData.append('family_list', args.data.checkedUsers);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сбрасываем данные формы
            yield put(familyFormAction(FAMILY_FORM_INITIAL));

            // Если редактировали абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если редактировали абонемент на странице с абонементами
            else {
                // Запрашиваем изменённые абонементы
                yield put(getSubscriptionsSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateSubscriptionFamilyList() {
    yield takeLatest(UPDATE_SUBSCRIPTION_FAMILY_LIST_SAGA, workerUpdateSubscriptionFamilyList);
}